import scrollLockMethod from './scrollLockMethod';

const refs = {
  byNowBtnRef: document.querySelector('.button-arrow-header'),
  menuBtnRef: document.querySelector('[data-menu-open]'),
  mobileMenuRef: document.querySelector('[data-menu]'),
  backdrop: document.querySelector('.backdrop'),
};

const classToggle = () => {
  refs.byNowBtnRef.classList.toggle('button-arrow-hidden');
  refs.menuBtnRef.classList.toggle('is-open');
  refs.mobileMenuRef.classList.toggle('is-open');
};

(function modal() {
  const links = document.querySelectorAll('.mobile-menu__menu-link');
  links.forEach(element => element.addEventListener('click', toggleModal));

  refs.menuBtnRef?.addEventListener('click', toggleModal);

  function toggleModal() {
    classToggle();
    const isMenuOpen = refs.mobileMenuRef.classList.contains('is-open');
    scrollLockMethod(isMenuOpen);
    window.addEventListener('keydown', listenerEscape);
  }

  function listenerEscape(event) {
    if (event.key === 'Escape') {
      classToggle();
      const isMenuOpen = refs.mobileMenuRef.classList.contains('is-open');
      scrollLockMethod(isMenuOpen);
      window.removeEventListener('keydown', listenerEscape);
    }
  }
})();
